import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchAllProducts, fetchProductDetails, fetchProductsByModel } from './productServices';
import { GetAllProductsResponse, GetProductDetailsResponse, GetProductsByModelResponse } from './productModels';

/**
 * Async thunk for fetching all products
 */
export const getAllProducts = createAsyncThunk<
  GetAllProductsResponse,
  void,
  { rejectValue: string }
>(
  'products/getAllProducts',
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchAllProducts();
      return data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.error || 'Failed to fetch products'
      );
    }
  }
);

/**
 * Async thunk for fetching product details
 */
export const getProductDetails = createAsyncThunk<
  GetProductDetailsResponse,
  string,
  { rejectValue: string }
>(
  'products/getProductDetails',
  async (productId: string, { rejectWithValue }) => {
    try {
      const data = await fetchProductDetails(productId);
      return data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.error || 'Failed to fetch product details'
      );
    }
  }
);

/**
 * Async thunk for fetching products by model
 */
export const getProductsByModel = createAsyncThunk<
  GetProductsByModelResponse,
  string,
  { rejectValue: string }
>(
  'products/getProductsByModel',
  async (model: string, { rejectWithValue }) => {
    try {
      const data = await fetchProductsByModel(model);
      return data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.error || 'Failed to fetch products by model'
      );
    }
  }
);

